<header id="headadmin">
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="card">
    <div class="card-header text-center" style="background-color: #be0c4d;">
      <h5 style="color: white;">Directorio - Administración de Variables FIVI</h5>
    </div>
    <div class="card-body">
      <div class="btn-toolbar justify-content-between" role="toolbar" aria-label="Toolbar with button groups">
        <button type="button" class="btn btn-secondary" (click)="regresarDirectorio()">Volver</button>
      </div>
      <div class="justify-content-md-center overflow-scroll">
        <table datatable [dtOptions]="dtOptions"  [dtTrigger]="dtTrigger" class="table table-bordered row-border hover datatable"
         id="table2excel">
          <thead>
            <tr>
              <th scope="col" class="text-center">NIT</th>
              <th scope="col" class="text-center">Razón Social</th>
              <th scope="col" class="text-center">Departamento</th>
              <th scope="col" class="text-center">Municipo</th>
              <th scope="col" class="text-center">Ver</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let fuente of fuentesFivi">
              <td scope="col">{{fuente.nit}}</td>
              <td scope="col">{{fuente.nombEntidad}}</td>
              <td scope="col">{{fuente.depto}}</td>
              <td scope="col">{{fuente.muni}}</td>
              <td  class="text-center">
                <a type="button" class="fa fa-edit" style="color: green;" (click)="goAdminVaribles(fuente.id)"></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</body>

<!--variables reporte FIVI-->
<div class="modal fade bd-example-modal-lg" id="modalVariablesFIVI" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header" style="background-color: crimson;">
        <h5 class="modal-title" id="modalVariablesFIVI">Variables Reporte FIVI</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <form action="">
          <div class=" container-fluid">

            <div class="row">
              <div class="col-6">
                <div><label><b>Razón Social</b></label></div>
                <div><input type="text" class="table-responsive" disabled></div>
              </div>
              <div class="col-6">
                <div><label><b>NIT</b></label></div>
                <div><input type="text" class="table-responsive" disabled></div>
              </div>
            </div>
          </div>
          <br>
          <div class="text-center">
            <b>Por favor seleccione las varibles a validar en el reporte:</b>
          </div>
          <br>
          <div class="justify-content-center">
            <div class="container-fluid">
              <div class="row">
                <div class="col-2" style="font-size: small;"><b>Nivel de Supervisión</b></div>
                <div class="col-3" style="font-size: small;"><b>Tipo de Crédito</b></div>
                <div class="col-2" style="font-size: small;"><b>Solución Vivienda</b></div>
                <div class="col-2" style="font-size: small;"><b>Rango de Vivienda</b></div>
                <div class="col-3" style="font-size: small;"><b>Tenedor</b></div>
              </div>
              <br>
              <div class="row">
                <div class="col-2" style="font-size: small;">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                  <label for="">Trimestral</label>
                </div>
                <div class="col-3" style="font-size: small;">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                  <label for="">Crédito de vivienda</label>
                </div>
                <div class="col-2" style="font-size: small;">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                  <label for="">Nueva</label>
                </div>
                <div class="col-2" style="font-size: small;">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                  <label for="">Sin clasificar</label>
                </div>
                <div class="col-3" style="font-size: small;">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                  <label for="">Propia en balance</label>
                </div>
              </div>
              <div class="row">
                <div class="col-2" style="font-size: small;">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                  <label for="">Semestral</label>
                </div>
                <div class="col-3" style="font-size: small;">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                  <label for="">Microcrédito inmobiliario</label>
                </div>
                <div class="col-2" style="font-size: small;">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                  <label for="">Usada</label>
                </div>
                <div class="col-2" style="font-size: small;">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                  <label for="">VIS</label>
                </div>
                <div class="col-3" style="font-size: small;">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                  <label for="">Propia fuera de balance</label>
                </div>
              </div>
              <div class="row">
                <div class="col-2" style="font-size: small;">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                  <label for="">Anual</label>
                </div>
                <div class="col-3" style="font-size: small;">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                  <label for="">Leasing habitacional</label>
                </div>
                <div class="col-2" style="font-size: small;">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                  <label for="">Sin clasificar</label>
                </div>
                <div class="col-2" style="font-size: small;">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                  <label for="">No VIS</label>
                </div>
                <div class="col-3" style="font-size: small;">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                  <label for="">Propia CISA</label>
                </div>
              </div>
              <div class="row">
                <div class="col-2" style="font-size: small;"></div>
                <div class="col-3" style="font-size: small;"></div>
                <div class="col-2" style="font-size: small;"></div>
                <div class="col-2" style="font-size: small;">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                  <label for="">VIP</label>
                </div>
                <div class="col-3" style="font-size: small;">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                  <label for="">Administrada - Titualación</label>
                </div>
              </div>
              <div class="row">
                <div class="col-2" style="font-size: small;"></div>
                <div class="col-3" style="font-size: small;"></div>
                <div class="col-2" style="font-size: small;"></div>
                <div class="col-2" style="font-size: small;"></div>
                <div class="col-3" style="font-size: small;">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                  <label for="">Administrada - Fogafin</label>
                </div>
              </div>
              <div class="row">
                <div class="col-2" style="font-size: small;"></div>
                <div class="col-3" style="font-size: small;"></div>
                <div class="col-2" style="font-size: small;"></div>
                <div class="col-2" style="font-size: small;"></div>
                <div class="col-3" style="font-size: small;">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                  <label for="">Administrada - Patrimonio autónimo</label>
                </div>
              </div>
              <div class="row">
                <div class="col-2" style="font-size: small;"></div>
                <div class="col-3" style="font-size: small;"></div>
                <div class="col-2" style="font-size: small;"></div>
                <div class="col-2" style="font-size: small;"></div>
                <div class="col-3" style="font-size: small;">
                  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                  <label for="">Administrada - Otras ventas</label>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
        <button type="button" class="btn btn-primary" style="background-color: crimson;">Guardar</button>
      </div>
    </div>
  </div>
</div>

